import { IPaginatedParams, PageInfo } from '../../share-types'
import { CreditBatchStatus } from '../credit-batches-container/share-type'

export type IPlanSubscription = {
  id: number
  userId: number
  planId: number
  initialOrderHistoryId?: number
  renewalMode: PlanSubscriptionRenewalMode
  wechatContractPlanId?: number
  contractCode?: string
  requestSerial?: string
  contractId?: string
  status: PlanSubscriptionStatus
  autoRenewStatus: PlanSubscriptionAutoRenewStatus
  currentPeriodStartedAt?: string
  currentPeriodEndsAt?: string
  nextBillingAt?: string
  signedAt?: string
  cancelledAt?: string
  createdAt: string
  updatedAt: string
  userName?: string
  planExternalId?: string
}

export type IPlanSubscriptionCycle = {
  id: number
  planSubscriptionId: number
  orderHistoryId: number
  status: PlanSubscriptionCycleStatus
  purchaseType: PlanSubscriptionCyclePurchaseType
  validFrom?: string
  validTo?: string
  createdAt: string
  updatedAt: string
  orderStatus?: string
  totalFee?: number
  creditBatch?: {
    id: number
    issuedCredits: number
    remainingCredits: number
    status: CreditBatchStatus
  }
}

export type IPlanSubscriptionDetails = {
  planSubscription: IPlanSubscription
  cycles: IPlanSubscriptionCycle[]
}

export enum PlanSubscriptionStatus {
  PENDING_PAYMENT = 'PENDING_PAYMENT',
  ACTIVE = 'ACTIVE',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  EXPIRED = 'EXPIRED',
  REFUNDED = 'REFUNDED',
}

export enum PlanSubscriptionAutoRenewStatus {
  PENDING_SIGNATURE = 'PENDING_SIGNATURE',
  ACTIVE = 'ACTIVE',
  CANCELLATION_PENDING = 'CANCELLATION_PENDING',
  CANCELLED = 'CANCELLED',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
}

export enum PlanSubscriptionRenewalMode {
  AUTO_RENEW = 'AUTO_RENEW',
  ONE_TIME = 'ONE_TIME',
}

export enum PlanSubscriptionCycleStatus {
  PENDING = 'PENDING',
  SCHEDULED = 'SCHEDULED',
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
}

export enum PlanSubscriptionCyclePurchaseType {
  INITIAL_PURCHASE = 'INITIAL_PURCHASE',
  AUTOMATIC_RENEWAL = 'AUTOMATIC_RENEWAL',
  MANUAL_RENEWAL = 'MANUAL_RENEWAL',
  EARLY_START = 'EARLY_START',
}

export type IPlanSubscriptionFilterParams = {
  id?: number
  userId?: number
  planId?: number
  status?: PlanSubscriptionStatus
  autoRenewStatus?: PlanSubscriptionAutoRenewStatus
  currentPeriodEndsAtFrom?: string
  currentPeriodEndsAtTo?: string
}

export type PlanSubscriptionFilter = IPaginatedParams & IPlanSubscriptionFilterParams

export type PaginatedPlanSubscriptions = {
  pageInfo: PageInfo
  data: IPlanSubscription[]
}
